export default function AppSection() {
  return (
    <section id="app" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-50 rounded-2xl p-8 md:p-10">
            <div className="flex-shrink-0">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-3xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20minimalist%20mobile%20app%20icon%20design%20with%20a%20crescent%20moon%20and%20a%20film%20reel%20combined%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20glowing%20edges%2C%20elegant%20simple%20rounded%20square%20icon%2C%20night%20cinema%20theme%20with%20dreamy%20atmospheric%20quality%2C%20clean%20modern%20design&width=400&height=400&seq=app-icon&orientation=squarish"
                  alt="春夜影院移动端"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">移动端体验</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                春夜影院移动端为你提供更加便捷的深夜观影体验。躺在床上、窝在沙发、或是在旅途中 —— 随时随地打开春夜影院，进入属于你的光影世界。支持夜间护眼模式、离线片单收藏和观影进度同步。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-apple-fill"></i>
                  </span>
                  App Store
                </button>
                <button className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-google-play-fill"></i>
                  </span>
                  Google Play
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}